import React from 'react'

type XLoaderProps = {
    size?: number,
    color1?: string,
    color2?: string,
    stroke?: number,
    duration?: number,
    className?: string,
    iterate?: 'infinite' | number
}

function XLoader({ size = 20, color1 = "toto-0", color2 = "toto-0", stroke = 10, duration = 0.25, className = "", iterate = 'infinite'}: XLoaderProps) {

    className += 'transition-slow hover:shadow-l hover:scale-120 hover:text-toto-2'

    return (
        <div className='-translate-x-1'>
            <svg viewBox="0 0 100 100" className={`text-${color1} ${className}`} style={{ width: size, height: size, animationDuration: `${duration}s`, animationIterationCount: iterate }} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round">
                {/* First diagonal */}
                <line x1="20" y1="20" x2="80" y2="80" strokeDasharray="100%" strokeDashoffset="100%" className="animate-stitch" style={{ animationDelay: `${duration}s` }}/>

                {/* Second diagonal (delayed) */}
                <line x1="80" y1="20" x2="20" y2="80" strokeDasharray="100%" strokeDashoffset="100%" className="animate-stitch"  />
            </svg>
            <svg viewBox="0 0 100 100" className={`text-${color2} ${className} translate-x-4 -translate-y-1`} style={{ width: size, height: size, animationDuration: `${duration}s`, animationIterationCount: iterate }} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round">
                {/* First diagonal */}
                <line x1="20" y1="20" x2="80" y2="80" strokeDasharray="100%" strokeDashoffset="100%" className="animate-stitch" style={{ animationDelay: `${duration*3}s` }}/>

                {/* Second diagonal (delayed) */}
                <line x1="80" y1="20" x2="20" y2="80" strokeDasharray="100%" strokeDashoffset="100%" className="animate-stitch" style={{ animationDelay: `${duration*2}s` }}/>
            </svg>
        </div>
    )
}

export default XLoader
